<template>

    <div  class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
    
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center absolute bg-white w-[600px] text-lg rounded-lg border-[2px] border-[#006A00]">
            <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                <p class="text-[#ffffff] text-md font-bold">CHANGE PASSWORD</p>
            </div>
            <div class="grid grid-cols-1 m-3 gap-2">
                <div class="relative">
                    <input :type="ShowPassword" class="col-span-1 rounded-md text-[#494949] border-[#cccccc] py-3 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="Enter Current Password"  v-model="currentPassword">
                    <button class="absolute right-5 top-2.5" @click="Showpass"><Showpassword/></button>
                </div>
                <div class="relative">
                    <input :type="ShowNewPassword" class="col-span-1 rounded-md text-[#494949] border-[#cccccc] py-3 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="Enter New Password"  v-model="password" @input="valPassword">
                    <button class="absolute right-5 top-2.5" @click="NshowPassword"><Showpassword/></button>
                </div>
                <div class="relative">
                    <input :type="ShowNewPassword" class="col-span-1 rounded-md text-[#494949] border-[#cccccc] py-3 px-5 border w-full text-sm outline-[#0B6014] mt-1" placeholder="Confirm Your New Password "  v-model="conpassword">
                    <button class="absolute right-5 top-2.5" @click="NshowPassword"><Showpassword/></button>
                </div>

                <div class="validation-results px-3">
                    <p :class="{'valid': isLengthValid, 'invalid': !isLengthValid}">
                      ✓ Minimum length: 8 characters
                    </p>
                    <p :class="{'valid': hasUppercase, 'invalid': !hasUppercase}">
                      ✓ Contains uppercase letter
                    </p>
                    <p :class="{'valid': hasLowercase, 'invalid': !hasLowercase}">
                      ✓ Contains lowercase letter
                    </p>
                    <p :class="{'valid': hasNumber, 'invalid': !hasNumber}">
                      ✓ Contains a number
                    </p>
                    <p :class="{'valid': hasSpecialChar, 'invalid': !hasSpecialChar}">
                      ✓ Contains special character
                    </p>
                  </div>

                <button class=" col-span-1 text-xs bg-[#006A00] rounded-lg text-[#fff] py-3 px-5 mt-4" @click="createPassword()">CHANGE PASSWORD</button>
            </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[150px]" @click="$emit('cancel')" >Close</button>
            </div>
        </div>
    </div>
    
    </template>
    
    <script>
    import { defineComponent } from 'vue';
    import Showpassword from "../../icons/ShowPassword.vue"
    
    
    export default defineComponent({
        components:{
            Showpassword
            
        },
        data(){
            return{
                currentPassword:'',
                password: '',
                conpassword: '',
                ShowPassword:'password',
                ShowNewPassword: 'password',
                isLengthValid: false,
                hasUppercase: false,
                hasLowercase: false,
                hasNumber: false,
                hasSpecialChar: false,
            }
        },
        mounted(){
    
        },
        methods:{
            createPassword(){
                if(this.isLengthValid && this.hasUppercase && this.hasLowercase  && this.hasNumber && this.hasSpecialChar ){
                    this.$emit('createNewPassword',this.currentPassword,this.password,this.conpassword)
                }
                else{
                    this.$emit('validPassword')
                }
            },
            Showpass(){
           
                if(this.ShowPassword == 'password'){
                    this.ShowPassword = 'text'
                }
                
                else if(this.ShowPassword === 'text'){
                    this.ShowPassword = 'password'
                }
               
            },
            NshowPassword(){
                if(this.ShowNewPassword == 'password'){
                    this.ShowNewPassword = 'text'
                }
                else if(this.ShowNewPassword === 'text'){
                    this.ShowNewPassword = 'password'
                }
    
            },
            valPassword() {
        // Reset the flags before each validation run
                this.isLengthValid    = false;
                this.hasUppercase     = false;
                this.hasLowercase     = false;
                this.hasNumber        = false;
                this.hasSpecialChar   = false;

                const lengthPattern = /.{8,}/;
                const uppercasePattern = /[A-Z]/;
                const lowercasePattern = /[a-z]/;
                const numberPattern = /\d/;
                const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
                const trimmedPassword = this.password.trim();

            this.isLengthValid = lengthPattern.test(trimmedPassword);
            this.hasUppercase = uppercasePattern.test(trimmedPassword);
            this.hasLowercase = lowercasePattern.test(trimmedPassword);
            this.hasNumber = numberPattern.test(trimmedPassword);
            this.hasSpecialChar = specialCharPattern.test(trimmedPassword);

            },
    
        }
    })
    </script>

<style scoped>
.password-validation {
  max-width: 400px;
  margin: 20px;
}



.validation-results p {

  font-size: 13px;
  color: #d9534f; /* Default red for invalid conditions */
}

.validation-results p.valid {
  color: #07c410; /* Green color for valid conditions */
}

.validation-results p.invalid {
  color: #d9534f; /* Red color for invalid conditions */
}

.error-message {
  color: red;


}
</style>